import { render, staticRenderFns } from "./EmpresasComponent.vue?vue&type=template&id=06569602&scoped=true"
import script from "./EmpresasComponent.vue?vue&type=script&lang=js"
export * from "./EmpresasComponent.vue?vue&type=script&lang=js"
import style0 from "./EmpresasComponent.vue?vue&type=style&index=0&id=06569602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06569602",
  null
  
)

export default component.exports